// WAParks booking strategy.
//
// URL shape:
//   ${site.reserveUrl}&arrival=yyyy/MM/dd&departure=yyyy/MM/dd

import { format } from "date-fns";
import { resolveCheckout } from "./_context.js";

export default {
  buildBookingUrl(ctx) {
    const { site, arrivalDate } = ctx;
    const checkout = resolveCheckout(ctx);
    return `${site.reserveUrl}&arrival=${format(arrivalDate, "yyyy/MM/dd")}&departure=${format(checkout, "yyyy/MM/dd")}`;
  },

  buildPreviewUrl(site) {
    return site.reserveUrl;
  },

  describeBookingInputs() {
    return {
      inputs: {
        arrivalDate: {
          status: "required",
          notes: "Encoded as &arrival=yyyy/MM/dd.",
        },
        departureDate: {
          status: "required",
          notes: "Encoded as &departure=yyyy/MM/dd.",
        },
        ref: {
          status: "ignored",
          notes: "site.reserveUrl already identifies the site.",
        },
        partySize: {
          status: "ignored",
          defaultValue: 1,
          notes: "Not encoded in the WAParks URL.",
        },
      },
    };
  },
};
